import { Stack, Typography, styled } from '@mui/material';
import { ImageIconLarge, ImageIconSmall } from '@shared/custom-icons';
import { useAppTFunction } from '@retail/app/i18n';

interface Props {
  isPreview?: boolean;
  noImageLabel?: string;
}

export const NoImageElement = ({ isPreview = true, noImageLabel }: Props) => {
  const t = useAppTFunction();

  return (
    <NoImageElementStack isPreview={isPreview}>
      {isPreview ? <ImageIconSmall /> : <ImageIconLarge />}

      {!isPreview && (
        <Typography
          variant="h5"
          fontWeight={500}
          sx={(theme) => ({
            marginTop: 2,
            color: 'grey.100',
            ...theme.applyStyles('dark', { color: 'text.disabled' }),
          })}
        >
          {noImageLabel ?? t('common.imageError')}
        </Typography>
      )}
    </NoImageElementStack>
  );
};

const NoImageElementStack = styled(Stack, {
  shouldForwardProp: (prop) => prop !== 'isPreview',
})<{ isPreview: boolean }>(({ theme, isPreview }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: isPreview ? 137 : '100%',
  height: isPreview ? 137 : '100%',
  borderRadius: Number(theme.shape.borderRadius) * 2,
  backgroundColor: isPreview ? theme.vars.palette.grey[50] : theme.vars.palette.background.paper,
}));
